var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "expand_more"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10090_1062",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10090_1062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "expand_more_2",
    d: "M7.99999 9.96676C7.9111 9.96676 7.82777 9.95288 7.74999 9.9251C7.67221 9.89732 7.59999 9.8501 7.53332 9.78343L4.46666 6.71676C4.34444 6.59454 4.28333 6.43899 4.28333 6.2501C4.28333 6.06121 4.34444 5.90565 4.46666 5.78343C4.58888 5.66121 4.74444 5.6001 4.93333 5.6001C5.12221 5.6001 5.27777 5.66121 5.39999 5.78343L7.99999 8.38343L10.6 5.78343C10.7222 5.66121 10.8778 5.6001 11.0667 5.6001C11.2555 5.6001 11.4111 5.66121 11.5333 5.78343C11.6555 5.90565 11.7167 6.06121 11.7167 6.2501C11.7167 6.43899 11.6555 6.59454 11.5333 6.71676L8.46666 9.78343C8.39999 9.8501 8.32777 9.89732 8.24999 9.9251C8.17221 9.95288 8.08888 9.96676 7.99999 9.96676Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand_more.4b188b66b0c998addd8b17658835ef1e.svg";
export { ForwardRef as ReactComponent };